module.exports = __webpack_public_path__ + "img/v-line-long.4a6b3b00.svg";